export default "__VITE_ASSET__BvXuKex5__"